/* eslint-disable angular/controller-name, angular/controller-as  */

angular.
module("dx.webapp.student").
controller("ExamStudentsSelectorController", function ExamStudentsSelectorController(
	$scope,
	$rootScope,

	examState,
	settingFlags,
	DX_URLS,
	DX_STUDENT_SORT_PREDICATE,
	dxSorting
) {
	"use strict";

	$scope.examState = examState;
	$scope.settingFlags = settingFlags;
	$scope.Urls = DX_URLS;

	angular.element(function initStudentOrder() {
		if ($scope.extendedProperties) {
			$scope.orderStudentsBy = angular.copy($rootScope.studentSortOptions);
		} else {
			$scope.orderStudentsBy = {
				predicate: DX_STUDENT_SORT_PREDICATE.NAME,
				reverse: false,
			};
		}
		$scope.students = dxSorting.studentSort($scope.students, $scope.orderStudentsBy);
	});

	$scope.setStudentsOrder = function setStudentsOrder(predicate) {
		$rootScope.studentSortOptions = {
			predicate: predicate,
			reverse: false,
		};

		if ($scope.anonymous && predicate === DX_STUDENT_SORT_PREDICATE.NAME) {
			$rootScope.studentSortOptions.predicate = DX_STUDENT_SORT_PREDICATE.ANONYMOUS_ID;
		}

		var conf = $scope.orderStudentsBy;
		if (conf.predicate === predicate) {
			conf.reverse = !conf.reverse;
			$rootScope.studentSortOptions.reverse = conf.reverse;
			$scope.students.reverse();
		} else {
			conf.predicate = predicate;
			conf.reverse = false;
			$scope.students = dxSorting.studentSort($scope.students, $rootScope.studentSortOptions);
		}
	};

	$scope.isItemSelected = function isItemSelected(item) {
		return $scope.selection.indexOf(item.id) > -1;
	};

	$scope.areAllItemsSelected = function areAllItemsSelected() {
		return $scope.selection.length === $scope.students.length;
	};

	$scope.toggleSelectItem = function toggleSelectItem(item) {
		var selection = $scope.selection;
		if ($scope.isItemSelected(item)) {
			return selection.splice(selection.indexOf(item.id), 1);
		}

		return selection.push(item.id);
	};

	$scope.toggleAllItems = function toggleAllItems() {
		if ($scope.areAllItemsSelected()) {
			$scope.selection = [];
		} else {
			$scope.selection = $scope.students.map(getId);
		}
	};

	function getId(item) {
		return item.id;
	}
});
